import { render, staticRenderFns } from "./NewsFeedSavingDialog.vue?vue&type=template&id=5d5d5032&scoped=true&"
import script from "./NewsFeedSavingDialog.vue?vue&type=script&lang=js&"
export * from "./NewsFeedSavingDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewsFeedSavingDialog.vue?vue&type=style&index=0&id=5d5d5032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5d5032",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VDialog,VRow,VSpacer})
